import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Container,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SecurePageSection from "../../SecurePageSection";

const EminenceGrp5Form = () => {
  const user = useSelector((state) => state.authentication.user);
  const [submitting, setSubmitting] = useState(false);

  const [regName, setregName] = useState("");
  const [grpName, setgrpName] = useState("");
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [grpPresName, setgrpPresName] = useState("");
  const [regChairName, setregChairName] = useState("");
  const [presNum, setpresNum] = useState("");
  const [accounts, setaccounts] = useState("");
  const [eminence, seteminence] = useState("");
  const [mangalyatra, setmangalyatra] = useState("");
  const [numEvents, setnumEvents] = useState("");

  const [regEmails, setRegEmails] = useState("");
  const [grpEmails, setGrpEmails] = useState("");

  // const [regConvenor, setRegConvenor] = useState("");

  const navigate = useNavigate();

  const fetchRegEmails = async () => {
    const chairmanResponse = await axios.get(
      `api/data/${regName}/region-ob/emails/`,
    );
    const chairmanEmail = chairmanResponse.data
      .filter((item) => item.post === "chairman")
      .map((item) => item.email);
    setRegEmails(chairmanEmail);

    const convenorResponse = await axios.get(
      `api/data/eminence/region-convenor/emails/`,
    );
    const convenorEmail = convenorResponse.data
      .filter(
        (item) =>
          item.post ===
            `${regName.charAt(0).toUpperCase() +
              regName.slice(1).toLowerCase()} Region Convenor` ||
          item.post ===
            `${regName.charAt(0).toUpperCase() +
              regName.slice(1).toLowerCase()} Region Coordinator`,
      )
      .map((item) => item.email);
    const chairmanName = chairmanResponse.data
      .filter((item) => item.post === "chairman")
      .map((item) => item.name);

    // setRegConvenor(convenorEmail);
    setregChairName(chairmanName);
  };

  useEffect(() => {
    fetchRegEmails();
  }, [regName]);

  const fetchGrpEmails = async () => {
    const grpResponse = await axios.get(`api/data/${grpName}/group/emails/`);
    const res = grpResponse?.data[0];
    setGrpEmails(res.presEmail + "," + res.secEmail);
    setgrpPresName(res.presName);
  };

  useEffect(() => {
    fetchGrpEmails();
  }, [grpName]);

  async function FormSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    let formField = new FormData();
    const finalEmail =
      "amish@vadilaljewels.com,dj22parekh@gmail.com,ritu26873@gmail.com,toralsheth.ts11@gmail.com" +
      "," +
      email;

    console.log(finalEmail);

    // if (!grpName) {
    //   alert("Please Submit your Region Name, Group Name");
    //   setSubmitting(false);
    //   return;
    // }

    formField.append("user", user?.user_id);
    formField.append("grpName", grpName);
    formField.append("name", name);
    formField.append("email", email);
    formField.append("grpPresName", grpPresName);
    formField.append("regChairName", regChairName);
    formField.append("presNum", presNum);
    formField.append("accounts", accounts);
    formField.append("eminence", eminence);
    formField.append("mangalyatra", mangalyatra);
    formField.append("numEvents", numEvents);

    events.forEach((event, index) => {
      formField.append(`subEvent${index + 1}`, event.subEvent);
      formField.append(`participants${index + 1}`, event.participants);
      formField.append(
        `coupleparticipants${index + 1}`,
        event.coupleparticipants,
      );
      formField.append(`type${index + 1}`, event.type);

      if (event.picEvent !== null) {
        formField.append(`picEvent${index + 1}`, event.picEvent);
      }
    });

    formField.append("emailList", finalEmail);

    await axios({
      method: "post",
      url: "/api/forms/ventures/eminence-5-groups/",
      data: formField,
    })
      .then(function(response) {
        console.log(response);
        navigate(`/eminence/5/response/${response.data.id}`, {
          replace: true,
        });
      })
      .catch(function(error) {
        console.log(error);
        // alert(
        //   "We encountered an error processing your request. Please try again later"
        // );
      });

    setSubmitting(false);
  }

  const [regions, setRegions] = useState([]);
  const fetchRegions = async () => {
    const response = await axios.get(`/user/region/`);
    setRegions(response.data);
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  const [groups, setGroups] = useState([]);
  const fetchGroups = async () => {
    const response = await axios.get(`/user/south/groups/`);
    setGroups(response.data);
  };
  useEffect(() => {
    fetchGroups();
  }, []);

  const [sgnGroups, setSgnGroups] = useState([]);
  const fetchSgnGroups = async () => {
    const response = await axios.get(`/user/south/sangini/`);
    setSgnGroups(response.data);
  };
  useEffect(() => {
    fetchSgnGroups();
  }, []);

  const initialEvents = [
    {
      subEvent: "",
      participants: "",
      coupleparticipants: "",
      type: "",
      picEvent: null,
    },
  ];

  const [events, setEvents] = useState(initialEvents);

  const addEvent = () => {
    if (events.length < 10) {
      setEvents([
        ...events,
        {
          subEvent: "",
          participants: "",
          coupleparticipants: "",
          type: "",
          picEvent: null,
        },
      ]);
    }
  };

  const removeEvent = (index) => {
    const updatedEvents = [...events];
    updatedEvents.splice(index, 1);
    setEvents(updatedEvents);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedEvents = [...events];
    updatedEvents[index][field] = value;
    setEvents(updatedEvents);
  };

  const handlePicEventChange = (index, file) => {
    const maxSizeInBytes = 2 * 1024 * 1024; // 2MB

    if (file && file.size > maxSizeInBytes) {
      alert(
        "File size exceeds the maximum allowed size (2MB). Please choose a smaller file.",
      );
      const fileInput = document.getElementsByName(`picEvent${index + 1}`)[0];
      fileInput.value = "";
    } else {
      const updatedEvents = [...events];
      updatedEvents[index].picEvent = file;
      setEvents(updatedEvents);
    }
  };

  const handleFileChange = (setState, event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      // Check if file size is less than 2MB
      if (selectedFile.size <= 1 * 1024 * 1024) {
        setState(selectedFile);
      } else {
        // File size exceeds 2MB, reset file input
        event.target.value = null;
        setState(null);
        // You can also provide feedback to the user, e.g., show an error message
        alert("File size must be less than 1MB.");
      }
    }
  };

  return (
    <div>
      <SecurePageSection accessableUsers={"admin,region,group,a"} />
      {/* <SecurePageSection accessableUsers={"admin,eminenceChair"} /> */}
      <Container>
        <Form>
          <Row>
            <Col lg={8}>
              <h2>Eminence Groups 5</h2>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col lg={6} xs={12}>
              <Form.Group>
                <Form.Label>Your Name</Form.Label>
                <Form.Control
                  name="name"
                  value={name}
                  placeholder="Respondant's Full name"
                  maxlength="500"
                  onChange={(e) => setname(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col lg={6} xs={12}>
              <Form.Group>
                <Form.Label>Your Email</Form.Label>
                <Form.Control
                  name="email"
                  value={email}
                  placeholder="Respondant's Email ID"
                  maxlength="500"
                  onChange={(e) => setemail(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            {(() => {
              if (
                user?.accessGroup === "admin" ||
                user?.accessGroup === "group"
              ) {
                return (
                  <Col lg={6} xs={12}>
                    <Form.Group>
                      <Form.Label>Group Name</Form.Label>
                      <Form.Select
                        name="grpName"
                        value={grpName}
                        maxlength="500"
                        onChange={(e) => setgrpName(e.target.value)}
                      >
                        <option>Select your Group</option>
                        <option>
                          {user.jsgGroupName.charAt(0).toUpperCase() +
                            user.jsgGroupName.slice(1).toLowerCase()}
                        </option>
                        {/* {groups.map((group, index) => (
                          <option
                            key={index}
                            style={{ textTransform: "capitalize" }}
                            value={group.group.toLowerCase()}
                          >
                            {group.group.charAt(0).toUpperCase() +
                              group.group.slice(1).toLowerCase()}
                          </option>
                        ))} */}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                );
              } else if (
                user?.accessGroup === "admin" ||
                user?.accessGroup === "sanginiGroup"
              ) {
                return (
                  <Col lg={6} xs={12}>
                    <Form.Group>
                      <Form.Label>Sangini Group Name</Form.Label>
                      <Form.Select
                        name="grpName"
                        value={grpName}
                        maxlength="500"
                        onChange={(e) => setgrpName(e.target.value)}
                      >
                        <option>Select your Group</option>
                        {sgnGroups.map((group, index) => (
                          <option
                            key={index}
                            style={{ textTransform: "capitalize" }}
                            value={group.group.toLowerCase()}
                          >
                            {group.group.charAt(0).toUpperCase() +
                              group.group.slice(1).toLowerCase()}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                );
              }
            })()}
            <Col lg={6} xs={12}>
              <Form.Group>
                <Form.Label>Group President Name</Form.Label>
                <Form.Control
                  style={{ textTransform: "capitalize" }}
                  name="grpPresName"
                  value={grpPresName}
                  placeholder="Group President's Full name"
                  maxlength="500"
                  onChange={(e) => setgrpPresName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>President Contact Number</Form.Label>
                <Form.Control
                  name="presNum"
                  value={presNum}
                  rows="3"
                  placeholder="Group President Contact Number"
                  maxlength="500"
                  onChange={(e) => setpresNum(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col lg={6} xs={12}>
              <Form.Group>
                <Form.Label>Accounts for 2025-2026 presented</Form.Label>
                <Form.Control
                  // as="textarea"
                  name="accounts"
                  value={accounts}
                  maxlength="500"
                  onChange={(e) => setaccounts(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={6}>
              <Form.Group>
                <Form.Label>Eminence forms filled</Form.Label>
                <Form.Control
                  name="eminence"
                  value={eminence}
                  // rows="3"
                  maxlength="500"
                  onChange={(e) => seteminence(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>Mangalyatra reports submitted</Form.Label>
                <Form.Control
                  name="mangalyatra"
                  value={mangalyatra}
                  // rows="1"
                  maxlength="500"
                  onChange={(e) => setmangalyatra(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  Events for the period 01st January 2026 to 31st March 2026
                </Form.Label>
                <Form.Control
                  name="numEvents"
                  value={numEvents}
                  rows="1"
                  maxlength="500"
                  onChange={(e) => setnumEvents(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <h3 style={{ marginTop: "30px", marginBottom: "10px" }}>Events</h3>
          <p>
            Note: Kindly Provide the details of the above mentioned Events and
            select the relevant type for each event
          </p>
          {events.map((event, index) => (
            <div key={index}>
              <Row>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    className="formSectionHeader"
                    style={{
                      marginTop: "10px",
                      width: "97%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h4 style={{ marginLeft: "30px" }}>{`Event ${index +
                      1}`}</h4>
                    {index > 0 && (
                      <Button
                        className="btn--secondary"
                        onClick={() => removeEvent(index)}
                      >
                        X
                      </Button>
                    )}
                  </div>
                </div>

                {/* Event Subject */}
                <Col md={6} xs={12}>
                  <Form.Group>
                    <Form.Label>
                      {`Event Subject ${index + 1}`} (Max 100 words)
                    </Form.Label>
                    <Form.Control
                      name={`subEvent${index + 1}`}
                      value={event.subEvent}
                      placeholder={`Subject of Event ${index + 1}`}
                      maxLength="500"
                      onChange={(e) =>
                        handleFieldChange(index, "subEvent", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>

                {/* Event Photo */}
                <Col md={6} xs={12}>
                  <Form.Group>
                    <Form.Label>
                      {`Event Photo ${index + 1}`}
                      <span style={{ fontSize: "14px" }}>
                        (Maximum file size: 2MB, accountst: jpg/jpeg only)
                      </span>
                    </Form.Label>
                    <Form.Control
                      name={`picEvent${index + 1}`}
                      type="file"
                      accept="image/jpg, image/jpeg"
                      onChange={(e) =>
                        handlePicEventChange(index, e.target.files[0])
                      }
                    />
                  </Form.Group>
                </Col>

                {/* Event Type (Dropdown) */}
                <Col md={4} xs={12}>
                  <Form.Group>
                    <Form.Label>{`Event Type ${index + 1}`}</Form.Label>
                    <Form.Select
                      name={`type${index + 1}`}
                      value={event.type}
                      onChange={(e) =>
                        handleFieldChange(index, "type", e.target.value)
                      }
                    >
                      <option value="">Select Event Type</option>
                      <option value="Regular Event">Regular Event</option>
                      {/* <option value="Federation Day Event">
                        Federation Day Event
                      </option>
                      <option value="Paryushan Special Event">
                        Paryushan Special Event
                      </option>
                      <option value="Festival Event">Festival Event</option> */}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Event Participants */}
                <Col md={4} xs={12}>
                  <Form.Group>
                    <Form.Label>{`Event Participants ${index + 1}`}</Form.Label>
                    <Form.Control
                      name={`participants${index + 1}`}
                      value={event.participants}
                      placeholder={`Number of Participants for Event ${index +
                        1}`}
                      type="number"
                      min="0"
                      onChange={(e) =>
                        handleFieldChange(index, "participants", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>

                <Col md={4} xs={12}>
                  <Form.Group>
                    <Form.Label>{`Event Couple Participants ${index +
                      1}`}</Form.Label>
                    <Form.Control
                      name={`coupleparticipants${index + 1}`}
                      value={event.coupleparticipants}
                      placeholder={`Number of Couple Participants for Event ${index +
                        1}`}
                      type="number"
                      min="0"
                      onChange={(e) =>
                        handleFieldChange(
                          index,
                          "coupleparticipants",
                          e.target.value,
                        )
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
          <Row style={{ marginTop: "10px" }}>
            <Col>
              {events.length < 10 ? (
                <Button className="btn--secondary" onClick={addEvent}>
                  Add Event
                </Button>
              ) : (
                <>
                  <Button className="btn--secondary" disabled>
                    Maximum 10 Events
                  </Button>
                  <p>Fill another form for more events</p>
                </>
              )}
            </Col>
          </Row>

          {submitting ? (
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-disabled">Submitting Please Wait</Tooltip>
              }
            >
              <Button
                style={{ marginTop: "30px" }}
                className="btn--outline--dark"
                disabled
              >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                Submiting
              </Button>
            </OverlayTrigger>
          ) : (
            <Button
              style={{ marginTop: "30px" }}
              className="btn--outline--dark"
              onClick={(e) => FormSubmit(e)}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              Submit
            </Button>
          )}
        </Form>
      </Container>
    </div>
  );
};

export default EminenceGrp5Form;
